import { isDirectCompareItemUrl } from "./directCompareUrl";

type CompareItemRow = Record<string, unknown>;

export const buildInitialDirectMyCompareItem = ({
  portalItemId,
  portalItem,
  directItemId,
  directItem,
  fallbackUrl,
  itemName,
}: {
  portalItemId: unknown;
  portalItem: unknown;
  directItemId: unknown;
  directItem: unknown;
  fallbackUrl: string;
  itemName: string;
}): { id: string; item: CompareItemRow } => {
  const existingId = String(directItemId || "").trim();
  const existingItem = typeof directItem === "object" && directItem !== null
    ? directItem as CompareItemRow
    : {};
  if (
    existingId && existingItem.item_id === existingId
    && isDirectCompareItemUrl(existingId, false)
  ) {
    return { id: existingId, item: existingItem };
  }

  if (!String(portalItemId || "").trim()) return { id: "", item: {} };
  const portalRow = typeof portalItem === "object" && portalItem !== null
    ? portalItem as CompareItemRow
    : {};
  const itemUrl = [portalRow.dest_url, portalRow.url, portalRow.item_url, fallbackUrl]
    .map((value) => String(value || "").trim())
    .find((value) => isDirectCompareItemUrl(value, false)) || "";
  if (!itemUrl) return { id: "", item: {} };

  return {
    id: itemUrl,
    item: {
      ...portalRow,
      item_id: itemUrl,
      item_url: itemUrl,
      item_title: portalRow.item_title || itemName,
    },
  };
};
